<ul class="c-sidebar-nav">
    <ng-template ngFor let-item [ngForOf]="menuItems">
        <li *ngIf="!item.children && !item.title" class="c-sidebar-nav-item">
            <a
                class="c-sidebar-nav-link"
                (click)="onAction($event)"
                [routerLink]="[item.route]"
                routerLinkActive="c-active"
                [routerLinkActiveOptions]="{ exact: item.routeExactMatch }"
                *ngIf="item.route"
            >
                <i class="c-sidebar-nav-icon {{ item.icon }}"></i>
                {{ item.name | translate }}
            </a>
            <a
                class="c-sidebar-nav-link"
                (click)="onAction($event)"
                [href]="[item.url]"
                routerLinkActive="c-active"
                *ngIf="item.url"
            >
                <i class="c-sidebar-nav-icon {{ item.icon }}"></i>
                {{ item.name | translate }}
            </a>
        </li>

        <ng-container *ngIf="item.title">
            <li class="c-sidebar-nav-divider"></li>
            <li class="c-sidebar-nav-title">{{ item.name | translate }}</li>
        </ng-container>

        <li class="c-sidebar-nav-dropdown" *ngIf="item.children">
            <a class="c-sidebar-nav-dropdown-toggle" href="#">
                <svg class="c-sidebar-nav-icon">
                    <use xlink:href="assets/icons/coreui/free-symbol-defs.svg#cui-cursor"></use>
                </svg>
                Buttons</a
            >
            <ul class="c-sidebar-nav-dropdown-items">
                <li class="c-sidebar-nav-item">
                    <a class="c-sidebar-nav-link" href="buttons/buttons.html"
                        ><span class="c-sidebar-nav-icon"></span> Buttons</a
                    >
                </li>
            </ul>
        </li>
    </ng-template>
</ul>
